/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
// import AsyncStorage from '@callstack/async-storage'
import {ASYNC_KEY, jnDecrypt} from '../utils/General'

var userSingleton = null

export const isAuthenticated = async () => {
  try {
    const value = await localStorage.getItem(ASYNC_KEY.IS_LOGINED);
    return value
  } catch (error) {
    return false
  }
}

export const storeToken = (token) => {
  localStorage.setItem(ASYNC_KEY.ACCESS_TOKEN, token)
}

export const logout = () => {
  localStorage.setItem(ASYNC_KEY.IS_LOGINED, false)
  localStorage.setItem(ASYNC_KEY.ACCESS_TOKEN, null)
  localStorage.setItem(ASYNC_KEY.USER, null)
  window.location.reload();
}

export const storeUserInfo = (data) => {
  localStorage.setItem(ASYNC_KEY.USER, data)
  localStorage.setItem(ASYNC_KEY.IS_LOGINED, true)
  window.location.reload();
}

export const Whoami = () => {
  var user = userSingleton

  if(user === null || user === undefined){
    user = {'role' : 'NA'}
  }
  return user
}

export const getUser = async () => {
  if(userSingleton){
    return userSingleton
  }
  let user = await localStorage.getItem(ASYNC_KEY.USER);

  let userDecrypted = null;
  if (user) {
    userDecrypted = await jnDecrypt(user);
  }
  userSingleton = userDecrypted
  return userDecrypted;
}
